module.exports = __webpack_public_path__ + "5e0ed7a99489333aa6d3243bda935cf4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-21.png
// module id = 1738
// module chunks = 0